// React-обёртка над createSlotGame. Пример для стека фронта (React 18 + i18next + socket.io-client).
// Монтирует слот в div, на размонтировании (уход со страницы) вызывает destroy() — он сам шлёт slot:close.
//
//   <SlotGame socket={socket} sound={me.sound} onBalanceChange={b => setHeaderBalance(b.shown)} ... />
//
// Пропсы-колбэки можно менять между рендерами: игра читает их через ref и не пересоздаётся.

import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createSlotGame } from './slot-game.js';
import './slot.css';

export default function SlotGame({ socket, sound = true, haptic, onBalanceChange, onDepositRequired, onLoginRequired, onNoFunds, onSoundChange, onAlert, className }) {
  const { t, i18n } = useTranslation();
  const ref = useRef(null);
  const gameRef = useRef(null);
  const cb = useRef({});
  cb.current = { onBalanceChange, onDepositRequired, onLoginRequired, onNoFunds, onSoundChange, onAlert };

  useEffect(() => {
    if (!socket || !ref.current) return undefined;
    const lang = i18n.language || 'ru';
    const game = createSlotGame(ref.current, {
      socket,
      // тексты из блока "slot" в locales/<язык>.json; нет перевода — встроенный русский
      t: (key, params) => (i18n.exists('slot.' + key) ? t('slot.' + key, { ...params, interpolation: { escapeValue: false } }) : null),
      locale: lang,
      dir: ['ar', 'fa'].includes(lang) ? 'rtl' : 'ltr',
      sound,
      // вибрация: { impact(style), notify(type), selection() }; берётся при создании игры
      haptic,
      onBalanceChange: b => cb.current.onBalanceChange && cb.current.onBalanceChange(b),
      onDepositRequired: () => cb.current.onDepositRequired && cb.current.onDepositRequired(),
      onLoginRequired: () => cb.current.onLoginRequired && cb.current.onLoginRequired(),
      onNoFunds: () => cb.current.onNoFunds && cb.current.onNoFunds(),
      onSoundChange: on => cb.current.onSoundChange && cb.current.onSoundChange(on),
      onAlert: a => cb.current.onAlert && cb.current.onAlert(a),
    });
    gameRef.current = game;
    return () => { game.destroy(); gameRef.current = null; };
    // пересоздаём только при смене сокета или языка
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, i18n.language]);

  useEffect(() => { if (gameRef.current) gameRef.current.setSound(sound); }, [sound]);

  return <div ref={ref} className={className} />;
}
